<template>
    <div>
        <h3 v-if="title != null">{{ title }}</h3>
        <select v-model="selectedValue">
            <option :value="null" selected>Selecione uma opção</option>
            <option v-for="item in options" :key="item.id" :value="item">
                {{ item.label }}
            </option>
        </select>
    </div>
</template>

<script>
export default {
    props: {
        /** Título a ser exibido acima do select, usado para descrever seu conteudo */
        title: { type: String, default: null },

        /** Um array de objetos contendo todos os dados
         * É necessário que cada objeto possua uma key de "label", contendo o nome a ser exibido no select.
         * Para isso, basta fazer um map adicionado a key label junto de seu valor, por exemplo:
         *
         * async getOptions() {
         *      let selectOptions = await service.getProdutos();
         *      let options = [
         *          {id: 23, produto: "Fundo T110"},
         *          {id: 24, produto: "Base quadrada"},
         *          {id: 25, produto: "Braço longo tipo C"},
         *          {id: 26, produto: "Botão do plug"},
         *      ]
         *      return options.map((option) => ({
         *          ...option,
         *          label: option.produto,
         *      }));
         * };
         */
        options: {
            type: Array,
            required: true,
            validator(value) {
                return value.every((option) => "label" in option);
            },
        },

        /** Variável que será atualizada quando uma opção for selecionada */
        modelValue: [String, Number, Date, Array, Object],

        /** Função de callback opicional para executar outra rotina qualquer */
        onSelect: { type: Function, default: null },
    },
    computed: {
        selectedValue: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit("update:modelValue", value);

                // Executa a função recebida via props, caso exista
                if (this.onSelect) {
                    this.onSelect(value);
                }
            },
        },
    },
};
</script>
